import { axios, Response } from '../index'

export const sendInviteTherapists = (personaId: string): Response<null> => {
  return axios.post(`/v1/personas/${personaId}/send-invite`)
}

export default sendInviteTherapists
